import { ChangeDetectionStrategy, Component, type OnInit } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from '@fino-ui/button';
import { SubmittableForm } from '@fino-ui/forms';
import { FinoInputModule } from '@fino-ui/input';
import { BaseModalComponent } from '@fino-ui/modal';
import { TranslationModule } from '@fino-ui/translation';
import { AppService } from 'src/app/app.service';
import { PleaseBePatientComponent } from '../../../../components/please-be-patient/please-be-patient.component';
import type { Features, ShowPaperSaved } from '../../kws.model';
import { KwsService } from '../../kws.service';

@Component({
  selector: 'app-sustainability',
  templateUrl: './sustainability.component.html',
  styleUrl: './sustainability.component.sass',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    TranslationModule,
    PleaseBePatientComponent,
    FormsModule,
    ReactiveFormsModule,
    FinoInputModule,
    ButtonModule,
  ],
})
export class SustainabilityComponent
  extends BaseModalComponent<{ features: Features }, ShowPaperSaved>
  implements OnInit
{
  constructor(
    private kwsService: KwsService,
    private appService: AppService,
  ) {
    super();
    Object.assign(this, this.data ?? {});
  }

  ngOnInit(): void {
    this.form.controls.isActive.valueChanges.subscribe((v) => {
      if (v === this.features.showPaperSaved.isActive) return;

      this.features.showPaperSaved.isActive = v;
      this.kwsService
        .changeKWSSettings({
          features: this.features,
        })
        .subscribe({
          next: () => {
            this.setLinkState(v);
            this.appService.success('sustainability.enable.success', {
              state: v ? 'aktiviert' : 'deaktiviert',
            });
          },
          error: () => {
            this.features.showPaperSaved.isActive = !v;
            this.form.patchValue({ isActive: !v });
            this.appService.error('sustainability.enable.error');
          },
        });
    });

    this.setLinkState(this.features.showPaperSaved?.isActive);

    this.form.setValue({
      link: this.features.showPaperSaved?.link,
      isActive: this.features.showPaperSaved?.isActive,
    });
  }

  setLinkState(enabled: boolean) {
    const linkControl = this.form.controls.link;
    enabled ? linkControl.enable() : linkControl.disable();
  }

  get formNotTouched() {
    return this.form.pristine && this.form.valid;
  }

  features: Features;

  form = new SubmittableForm({
    link: new FormControl(''),
    isActive: new FormControl(false),
  });

  abort() {
    this.close();
  }

  submit() {
    this.result = this.form.value;
    this.close();
  }
}
